<template>
  <div class="Message">
    <div class="Message_mask" @click="close"></div>
    <Shape ref="shape" />
    <div class="Message_wrapper">
      <img class="Message_thumb" :src="'/assets/images/' + message.thumb" v-if="message.thumb" />
      <div class="Message_content">
        <transition name="title" appear>
          <h3 v-html="message.title" v-if="message.title"></h3>
        </transition>

        <transition name="content" appear>
          <p v-if="message.content" v-html="message.content">Lorem ipsum delor ritum</p>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import Shape from '@/components/partial/Shape'
  export default {
    props: [ 'message' ],
    components: { Shape },
    methods: {
    close()
      {
        this.close = new Howl({
          src: ['/assets/sounds/close.mp3']
        });
        this.close.play()

        this.$el.querySelector('.Shape').classList.remove('Shape_message')
        this.$emit('closeMessage')
      }
    },
    created () {
    },
    mounted () {
      setTimeout( () => {
        this.$el.querySelector('.Shape').classList.add('Shape_message')
      }, 10)
      
      this.open = new Howl({
        src: ['/assets/sounds/open.mp3']
      });
      this.open.play()
      
      this.pirate = new Howl({
        src: ['/assets/sounds/pirate.mp3']
      });
      this.pirate.play()

      this.$ga.event('indice_pirate', 'open' );

    }
  }
</script>

<style lang="stylus">
.Message

  position fixed
  bottom 0px
  right -80px
  display flex
  flex-direction column
  align-items center
  justify-content center



  &_mask

    position fixed
    top 0px
    left 0px
    width 100%
    height 100%
    pointer-events auto
    z-index 10
    cursor pointer

  &_content

    padding 0px 160px 0px 0px 

    @media $small

      padding-right 100px

  &_wrapper

    display flex
    flex-direction row
    align-items center
    position relative
    justify-content flex-start
    width 100%
    max-width 720px
    box-sizing border-box
    padding 50px 0px 80px 50px 

    @media $small

      padding 0px 0px 40px 25px
      align-items flex-start

  &_thumb

    width 90px
    margin-right 20px

    @media $small

      width 60px

  p

    margin-bottom 0px
    margin-top 10px

</style>